import React from 'react';
import { Lightbulb, Sparkles, TrendingDown, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';
export function InsightsPanel({ title = 'Insights', insights, empty, className, }) {
    return (<Card className={cn('border-border/60 bg-card/40 backdrop-blur-sm', className)}>
            <CardHeader className="gap-1 pb-3">
                <CardTitle className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
                    <Sparkles className="h-4 w-4" aria-hidden/>
                    {title}
                </CardTitle>
            </CardHeader>
            <CardContent className="pt-0">
                {insights.length === 0 ? (<div className="flex h-24 items-center justify-center rounded-md bg-muted/20 text-sm text-muted-foreground">
                        {empty ?? 'Not enough data to surface insights yet.'}
                    </div>) : (<ul className="space-y-2">
                        {insights.map((insight) => (<li key={insight.key} className={cn('flex items-start gap-3 rounded-md border px-3 py-2.5', insight.tone === 'positive' && 'border-emerald-500/30 bg-emerald-500/5', insight.tone === 'negative' && 'border-rose-500/30 bg-rose-500/5', insight.tone === 'neutral' && 'border-border/60 bg-muted/20')}>
                                <div className={cn('mt-0.5 shrink-0', insight.tone === 'positive' && 'text-emerald-600 dark:text-emerald-400', insight.tone === 'negative' && 'text-rose-600 dark:text-rose-400', insight.tone === 'neutral' && 'text-muted-foreground')}>
                                    {insight.tone === 'positive' ? (<TrendingUp className="h-4 w-4" aria-hidden/>) : insight.tone === 'negative' ? (<TrendingDown className="h-4 w-4" aria-hidden/>) : (<Lightbulb className="h-4 w-4" aria-hidden/>)}
                                </div>
                                <div className="min-w-0 space-y-0.5">
                                    <p className="text-sm font-medium text-foreground">{insight.title}</p>
                                    {insight.body ? (<p className="text-xs text-muted-foreground">{insight.body}</p>) : null}
                                </div>
                            </li>))}
                    </ul>)}
            </CardContent>
        </Card>);
}
